import React, { useState } from 'react';
import orderBy from 'lodash/orderBy';
import { ContainerType, ShippingLine, SnapshotUrl, Terminal } from 'types/Shipping';
import { SnapshotPreview } from '../SnapshotPreview';
import { Download } from '../Download';
import { PerDiem } from './types';
import { PerDiemList } from './PerDiemList';

interface TabContentProps {
  perDiem: PerDiem[];
  terminal?: Terminal;
  snapshotUrl?: SnapshotUrl;
  shippingLines: ShippingLine[];
  containerTypes: ContainerType[];
}

export const TimeRangeTabContent: React.FC<TabContentProps> = (props) => {
  const { perDiem, terminal, snapshotUrl, shippingLines, containerTypes } = props;

  const orderedPerDiem = perDiem ? orderBy(perDiem, 'new_last_update', 'desc') : [];
  const [selected, setSelected] = useState(orderedPerDiem[0]?.key);

  if (!perDiem) {
    return (
      <div className="mt-8">
        <h2>No data</h2>
      </div>
    );
  }
  if (perDiem.length === 0) return null;

  let snapshot: SnapshotUrl | null = null;

  if (snapshotUrl?.key === selected) {
    snapshot = snapshotUrl;
  } else {
    const foundPerDiem = orderedPerDiem.find((pd) => pd.key === selected);
    snapshot = foundPerDiem ? foundPerDiem.snapshot : null;
  }

  return (
    <div className="min-h-[625px] border rounded grid grid-cols-1 md:grid-cols-2 overflow-hidden bg-white">
      <div className="p-12 space-y-4">
        <img src={terminal?.logo} alt={terminal?.name} className="h-[35px]" />
        <PerDiemList
          selected={selected}
          setSelected={setSelected}
          orderedPerDiem={orderedPerDiem}
          snapshotUrl={snapshotUrl}
          shippingLines={shippingLines}
          containerTypes={containerTypes}
        />
      </div>
      <div className="bg-gray-100 p-12 flex flex-col items-center gap-2">
        <div className="max-h-[300px] overflow-hidden flex">
          <SnapshotPreview key={selected} url={snapshot ? snapshot.url : ''} />
        </div>
        {snapshot && snapshot.url && <Download snapshot={snapshot} />}
      </div>
    </div>
  );
};
